import React from 'react'
import { createRoot } from 'react-dom/client'

import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'
import { BrowserRouter } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from 'react-query'

import './Vendor/fontawesome-pro/css/all.min.css'
import './polyfills'
import './assets/base.scss'
import Main from './Pages'
import * as serviceWorker from './serviceWorker'
import { persistor, store } from './Redux/Config/configureStore'
import Routes from './Pages/Routes/routes'
import ErrorAlert from './CMSComponent/errorAlert'

const queryClient = new QueryClient()

const rootElement = document.getElementById('root')
const root = createRoot(rootElement)

const renderApp = () => {
  root.render(
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <Provider store={store}>
          <PersistGate loading={null} persistor={persistor}>
            <Routes />
            <ErrorAlert />
          </PersistGate>
        </Provider>
      </QueryClientProvider>
    </BrowserRouter>
  )
}

renderApp(Main)

serviceWorker.unregister()
